import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RevealDirective } from '../../core/directives/reveal.directive';
import { IconComponent, HxIconName } from '../../core/icons/icon.component';

interface Project {
  icon: HxIconName;
  tag: string;
  title: string;
  body: string;
}

@Component({
  selector: 'hx-track-record',
  standalone: true,
  imports: [MatCardModule, RevealDirective, IconComponent],
  template: `
    <section id="work">
      <div class="wrap">
        <div class="section-head reveal" appReveal>
          <p class="eyebrow">Track record</p>
          <h2>Delivered, across sectors and borders.</h2>
          <p>A sample of what's already live — from local government to international clients.</p>
        </div>

        <div class="grid-3">
          @for (item of projects; track item.title) {
            <div class="reveal" appReveal>
              <mat-card class="card" appearance="outlined" style="border:none">
                <mat-card-content style="padding:0">
                  <div class="card-icon">
                    <hx-icon [name]="item.icon"></hx-icon>
                  </div>
                  <span class="case-tag" style="margin-bottom:8px">{{ item.tag }}</span>
                  <h3>{{ item.title }}</h3>
                  <p>{{ item.body }}</p>
                </mat-card-content>
              </mat-card>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class TrackRecordComponent {
  projects: Project[] = [
    { icon: 'bank', tag: 'Banking · Philippines', title: 'Banking System', body: 'Core banking system delivered for local banks in the Philippines, built for accuracy and uptime.' },
    { icon: 'document', tag: 'Government · LGU', title: 'Document Management System', body: 'Records digitization and workflow tooling built for a local LGU to manage documents end to end.' },
    { icon: 'shield', tag: 'Government · EU', title: 'SecureGov Portal', body: 'A secure government services portal built and delivered for public-sector clients in the EU.' },
    { icon: 'check-shield', tag: 'Compliance · Ireland', title: 'Audit Fixers', body: 'Security and compliance audit remediation delivered for Cyberhealth Limited, Ireland.' },
    { icon: 'mobile', tag: 'Mobile & Web', title: 'Mobile App & Website Projects', body: 'Native and cross-platform apps, plus marketing and product websites, shipped across industries.' },
    { icon: 'integration', tag: 'Integrations', title: 'Systems Integrations', body: 'Core systems, APIs, and third-party platforms connected into one working stack.' },
    { icon: 'ledger', tag: 'Business Systems', title: 'CRM & Accounting Tools', body: 'Custom CRM and accounting/finance tooling, built around how teams actually work.' },
    { icon: 'transfer', tag: 'Delivery Model', title: 'Build, Operate & Transfer', body: 'End-to-end delivery: we build the system, run it, then hand over full ownership to your team.' },
  ];
}
